<template>
  <div class="background">
  <div class="chart-container">
    <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <img src="../../assets/LOGO.png">
      </div>
      <div class="main-header-right">
        <p>{{$t('sensorOlRe')}}</p>
        <p style="font-size: 13px;">{{$t('period')}}: {{timeRange3}}</p>
      </div>
    </div>
    <table class="status-table1" :class="{'zh1':!isEn,'de1':isDe||isIt||isFr}">
      <tr>
        <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
        <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
      </tr>
      <tr>
        <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
        <td class="td2" id="reportPdmTitle">{{$t('pdm')}}</td><td colspan="8" class="td3">{{devices[0]}}</td>
      </tr>
      <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{devices[1]}}</td></tr>
      <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{devices[2]}}</td></tr>
      <tr>
        <td class="td1 td4">{{$t('disType')}}</td><td colspan="9" class="td4">{{statics.medical_history}}</td>
        <!--<td class="td td4">{{$t('HbA1c')}}</td><td colspan="4">{{hb1c[0]}}</td>-->
      </tr>
    </table>

    <div class="small-hr"></div>
    <el-row>
      <el-col :span="24">
        <img id="img3_1" class="graph">
      </el-col>
    </el-row>
    <div class="spe-hr"></div>

    <div class="legend-group">
      <div class="legend" v-show="show.A"><img src="../../assets/Line_1.png"><span>{{legendDate[0]}}</span></div>
      <div class="legend" v-show="show.B"><img src="../../assets/Line_2.png"><span>{{legendDate[1]}}</span></div>
      <div class="legend" v-show="show.C"><img src="../../assets/Line_3.png"> <span>{{legendDate[2]}}</span></div>
      <div class="legend" v-show="show.D"><img src="../../assets/Line_4.png"><span>{{legendDate[3]}}</span></div>
      <div class="legend" v-show="show.E"><img src="../../assets/Line_5.png"><span>{{legendDate[4]}}</span></div>
      <div class="legend" v-show="show.F"><img src="../../assets/Line_6.png"><span>{{legendDate[5]}}</span></div>
      <div class="legend" v-show="show.G"><img src="../../assets/Line_7.png"><span>{{legendDate[6]}}</span></div>
      <div class="legend" style="margin-bottom: 30px;"><img src="../../assets/Average.png"><span>{{$t('Average')}}</span></div>
    </div>
    <div class="statics">
      <table class="statics-table">
        <tr>
          <td class="td1">{{$t('date')}}</td><td class="td1">{{$t('Avg')}}</td> <td class="td1">{{$t('min')}}</td>
          <td class="td1">{{$t('max')}}</td> <td class="td2">{{$t('ofhypo')}}</td>
        </tr>
        <tr v-for="(item,i) in date" v-show="item">
          <td class="td1">{{item}}</td><td class="td1">{{glucose[i].avg}}</td>
          <td class="td1">{{glucose[i].min}}</td><td class="td1">{{glucose[i].max}}</td> <td class="td2">{{glucose[i].nh}}</td>
        </tr>
        <tr>
          <td class="td3">{{$t('overall')}}</td> <td class="td3">{{glucose[glucoseLength].avg}}</td> <td class="td3">{{glucose[glucoseLength].min}}</td>
          <td class="td3">{{glucose[glucoseLength].max}}</td> <td>{{glucose[glucoseLength].nh}}</td>
        </tr>
      </table>
    </div>
    <div class="page-end"></div>
  </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
    import format from '@/lib/format'
  import B64 from '../../auth/base64'
  export default{
    data() {
      return {
         timeRange3:'', weekmode:'yyyyyyy',isEn:false,isMg:'',ts:[],isDe:false,
         legendDate:[], show:{}, uid:0,st:0,et:0,isIt:false,
        statics:{},devices:['--','--','--'],hb1c:['--'],
        glucose:[[],[],[],[],[],[],[],[]],glucoseLength:7,date:[],isFr:false,
      }
    },
    methods:{
      checkLegend(){
        this.legendDate =[];
        this.show = {A:false,B:false,C:false,D:false,E:false,F:false,G:false,};
        this.legendDate = JSON.parse(sessionStorage.getItem('legendDate3'));
        if(this.legendDate[0]){this.show.A = true;}
        if(this.legendDate[1]){this.show.B = true;}
        if(this.legendDate[2]){this.show.C = true;}
        if(this.legendDate[3]){this.show.D = true;}
        if(this.legendDate[4]){this.show.E = true;}
        if(this.legendDate[5]){this.show.F = true;}
        if(this.legendDate[6]){this.show.G = true;}

        let length = this.ts.length;
        this.glucoseLength = length;
        for(let i=0;i<length;i++){
            let t = format.formatterDate9(this.ts[i][0]);
            t[1] = t[1]+1;
            t[1]=  t[1]<10 ? ('0'+ t[1] ):  t[1];
            t[2] = t[2]<10 ? ('0'+ t[2]) :  t[2];
            this.date[i] = t[2]+'-'+t[1]+'-'+t[0];
        }
      },
      getStatics(param){
        this.$http.get('api/v2.1/report/'+this.uid+'/data/ol',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            if ('EasyPatch'==this.devices[0]) {
              document.getElementById('reportPdmTitle').innerHTML='APP';
            }
            this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
            this.glucose = (data.sg_stat)?data.sg_stat:this.glucose;
            //console.log(this.glucose )
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },

      getStatics2(report_data){
        //console.log('report_data:', report_data);
        //let data =  res.data.data;
        let data=report_data;
        data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
        this.statics = data;
        this.devices = (data.devices)?data.devices:this.devices;
        this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
        this.glucose = (data.sg_stat)?data.sg_stat:this.glucose;
        //console.log(this.glucose )
      },

      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title = this.$t('sensorOlRe');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.et= parseInt(sessionStorage.getItem('et3'));
      this.st= parseInt(sessionStorage.getItem('st3'));
      this.weekmode = sessionStorage.getItem('week3');
      this.timeRange3 = sessionStorage.getItem('timeRange3');
      this.ts = auth.getTs2(this,this.st,this.et);
      let param = {
        ts:this.ts,
        tz:parseInt(sessionStorage.getItem('tz')),
        weekmode:this.weekmode,
        gu:(this.isMg)?'mg/dL':'mmol/L',
      };
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      param = B64.base64encode(JSON.stringify(param));
      let img1 = document.getElementById('img3_1');
      img1.src = sessionStorage.getItem('src3_1');
      this.checkLegend();
      //this.getStatics(param);
      let report_data=sessionStorage.getItem('ol_report_data')
      report_data=JSON.parse(report_data)
      this.getStatics2(report_data)

      setTimeout(auth._printPdf(),2000);
    },
  }
</script>

<style scoped meadia="print">
  @page{
    *size:auto;
    size:portrait;
    margin: 0;
  }
  .background{
    padding-top: 5mm;
    width: 100%;
    *height: 297mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:210mm;
    *height:297mm;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }

  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
    font-size:12px;
  }
  .status-table1 td{
    padding-left: 8px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh1 .td1{
    width: 12%;
  }
  .zh1 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .status-table1 .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }
  .spe-hr{
    width:94%;
    border-top:1px solid #e6e8ea;
    margin:20px auto 20px;
  }
  .chart-container .graph{
    width:97%;
    height:540px;
    margin-left: 2%;
    margin-bottom: 5px;
  }

  .legend-group{
    width:98%;
    margin-left: 3%;
    font-family:SFUIText-Regular;
    font-size:10px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .legend{
    float:left;
    margin-bottom: 8px;
    margin-right:50px;
    height:20px;
    line-height: 20px;
  }
  .legend img{
    margin-right: 8px;
    margin-bottom: 4px;
  }

  .statics{
    clear: both;
  }
  .statics-table{
    width: 94%;
    margin:0 auto;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .statics-table td{
    height:17px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .page-end {
    clear:both;
    height:10mm;
  }

</style>



// WEBPACK FOOTER //
// chart3_print.vue?92559a22